import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import React, { useMemo } from 'react';
import { Goal } from 'shared/types/goal';

import * as Styled from './goal-list.style';
import { GoalListItem } from './goal-list-item';

export type GoalListProps = Omit<
  React.ComponentProps<typeof GoalListItem>,
  'goals' | 'goal' | 'hasDnd'
> & {
  goals: Goal[];
  allGoals: Goal[];
  canReorder?: boolean;
};

export const GoalList: React.FC<GoalListProps> = ({
  goals,
  allGoals,
  canReorder,
  ...rest
}) => {
  const Wrapper = canReorder ? SortableContext : React.Fragment;
  const wrapperProps = useMemo(
    () =>
      canReorder
        ? {
            items: goals.map(({ id }) => id),
            strategy: verticalListSortingStrategy,
          }
        : ({} as { items: string[] }),
    [canReorder, goals],
  );

  return (
    <Wrapper {...wrapperProps}>
      <Styled.List>
        {goals.map((goal) => (
          <Styled.ListItem key={goal.id}>
            <GoalListItem
              goal={goal}
              goals={allGoals}
              hasDnd={canReorder}
              {...rest}
            />
          </Styled.ListItem>
        ))}
      </Styled.List>
    </Wrapper>
  );
};
